module.exports = __webpack_public_path__ + "static/media/GSuiteButton.09279d0a.png";